const REPLACEABLE_CHARACTERS = {
    "á": "a",
    "ã": "a",
    "â": "a",
    "é": "e",
    "ê": "e",
    "í": "i",
    "ó": "o",
    "ô": "o",
    "ç": "c"
}

/**
 * The main purpose of this method is to add the indexer property
 * to the main location data object.
 * */
export const parseLocationData = (locationData) => {
    if (!locationData) {
        return {};
    }

    let regionIndex = locationData.name?.toLowerCase();

    Object.keys(REPLACEABLE_CHARACTERS).forEach(key => {
        regionIndex = regionIndex.replaceAll(
            `${key}`,
            REPLACEABLE_CHARACTERS[key],
        )
    })

    return {
        ...locationData,
        regionIndex
    };
}
